<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">开票设置</span>
      </div>
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span>增值税专用发票</span>
        <el-switch
          v-model="value1"
          style="margin-left: 10px"
          active-value="1"
          inactive-value="0"
          @change="handleChange"
        />
        <span v-show="value1 == '1'">开启</span>
        <span v-show="value1 == '0'">关闭</span>
      </el-row>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电通知</span>
      </div>
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span>短信通知</span>
        <el-switch
          v-model="value2"
          style="margin-left: 10px"
          active-value="1"
          inactive-value="0"
          @change="handleChange1"
        />
        <span v-show="value2 == '1'">开启</span>
        <span v-show="value2 == '0'">关闭</span>
      </el-row>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <span class="title">异常停充通知</span>
      </div>
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span>短信通知</span>
        <el-switch
          v-model="value3"
          style="margin-left: 10px"
          active-value="1"
          inactive-value="0"
          @change="handleChange2"
        />
        <span v-show="value3 == '1'">开启</span>
        <span v-show="value3 == '0'">关闭</span>
      </el-row>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电阈值</span>
      </div>
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="最低额度" prop="input" style="margin-top: 10px">
          <el-input
            v-model="form.input"
            placeholder="请输入最低额度"
            style=" width: 200px"
          />
          <span style="margin-left: 10px">元</span>
          <el-button
            type="primary"
            plain
            style="margin-left: 50px"
            @click="save"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <span class="title">积分获取规则</span>
      </div>
      <el-form ref="integralForm" inline :model="integralForm" :rules="integralRule" class="demo-ruleForm">
        <el-form-item label="一次充电每满" label-width="120px" prop="degrees" style="margin-top: 10px">
          <el-input
            v-model="integralForm.degrees"
            placeholder="度数"
            style="width: 200px"
          >
            <template slot="append">度</template>
          </el-input>
        </el-form-item>
        <el-form-item label=" " label-width="0px" prop="integral" style="margin-top: 10px">
          <el-input
            v-model="integralForm.integral"
            placeholder="积分"
            style="width: 200px"
          >
            <template slot="append">积分</template>
          </el-input>
        </el-form-item>
        <el-form-item label=" " label-width="0px" style="margin-top: 10px">
          <el-button
            type="primary"
            plain
            style="margin-left: 50px"
            @click="saveIntegral"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <div slot="header">
        <span class="title">经验值获取规则</span>
      </div>
      <el-form ref="empiricalForm" inline :model="empiricalForm" :rules="empiricalRule" class="demo-ruleForm">
        <el-form-item label="一次充电每满" label-width="120px" prop="degrees" style="margin-top: 10px">
          <el-input
            v-model="empiricalForm.degrees"
            placeholder="度数"
            style="width: 200px"
          >
            <template slot="append">度</template>
          </el-input>
        </el-form-item>
        <el-form-item label=" " label-width="0px" prop="empirical" style="margin-top: 10px">
          <el-input
            v-model="empiricalForm.empirical"
            placeholder="经验值"
            style="width: 200px"
          >
            <template slot="append">经验值</template>
          </el-input>
        </el-form-item>
        <el-form-item label=" " label-width="0px" style="margin-top: 10px">
          <el-button
            type="primary"
            plain
            style="margin-left: 50px"
            @click="saveEmpirical"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">其他</span>
      </div>
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span>是否支持OCR识别</span>
        <el-switch
          v-model="value6"
          style="margin-left: 10px"
          active-value="1"
          inactive-value="0"
          @change="handleChange6"
        />
        <span v-show="value6 == '1'">开启</span>
        <span v-show="value6 == '0'">关闭</span>
      </el-row>
    </el-card>
  </div>
</template>
<script>
const token = window.localStorage.getItem('token')
export default {
  name: 'Xitongshezhi',
  components: {},
  data() {
    var checkNum = (rule, val, callback) => {
      if (!val) {
        return callback(new Error('请输入最低额度'))
      } else {
        const reg = /^0$|^[1-9]\d{0,15}$|^[1-9]\d{0,15}\.{1}\d{1,4}$|^0\.{1}\d{1,4}$/g // \d+(?:\.\d{1,4})?    \d{1,16}$|^(\d{1,16}\.{1}\d{1,4})
        if (reg.test(val)) {
          callback()
        } else {
          return callback(new Error('请输入正确数值'))
        }
      }
    }

    var checkNum1 = (rule, value, callback) => {
      const strP = /^[1-9]\d*$/
      if (!value) {
        callback(new Error(`不能为空`))
      } else if (!strP.test(value)) {
        callback(new Error(`请输入正整数`))
      } else {
        callback()
      }
    }
    return {
      id1: '',
      value1: '0',
      id2: '',
      value2: '0',
      value3: '0',
      id3: '',
      id4: '',
      id5: '',
      id6: '',
      id8: '',
      value6: '0',
      form: {
        input: ''
      },
      rules: {
        input: [
          { required: true, message: '请输入最低额度', trigger: 'blur' },
          { validator: checkNum, trigger: 'blur' }
        ]
      },
      integralForm: {
        degrees: '',
        integral: ''
      },
      integralRule: {
        degrees: [
          { required: true, message: '请输入度数', trigger: 'blur' },
          { validator: checkNum1, trigger: 'blur' }
        ],
        integral: [{ validator: checkNum1, trigger: 'blur' }]
      },
      empiricalForm: {
        degrees: '',
        empirical: ''
      },
      empiricalRule: {
        degrees: [
          { required: true, message: '请输入度数', trigger: 'blur' },
          { validator: checkNum1, trigger: 'blur' }
        ],
        empirical: [{ validator: checkNum1, trigger: 'blur' }]
      }
    }
  },
  computed: {
    headers() {
      return {
        token: token
      }
    }
  },
  mounted() {
    this.getValue()
  },
  methods: {
    getValue() {
      this.$store.dispatch('form/handle', {
        url: '/setting',
        method: 'get',
        callback: (resp) => {
          if (resp) {
            resp.forEach(element => {
              if (element.type === 'TAX_SWITCH') {
                this.id1 = element.id
                this.value1 = element.value
              } else if (element.type === 'SMS_SWITCH') {
                this.id2 = element.id
                this.value2 = element.value
              } else if (element.type === 'CHARGE_MIN_BALANCE') {
                this.id3 = element.id
                this.form.input = element.value
              } 
              else if (element.type === 'ABNORMAL_CHARGE_NOTICE_SWITCH') {
                this.id8 = element.id
                this.value3= element.value
              } 
              else if (element.type === 'PERSONAL_POINTS') {
                this.id4 = element.id
                const arr = element.value ? element.value.split('|') : ['', '']
                this.integralForm = {
                  degrees: arr[0],
                  integral: arr[1]
                }
              } else if (element.type === 'EMPIRICAL_VALUE') {
                this.id5 = element.id
                const arr = element.value ? element.value.split('|') : ['', '']
                this.empiricalForm = {
                  degrees: arr[0],
                  empirical: arr[1]
                }
              } else if (element.type === 'OCR_SWITCH') {
                this.id6 = element.id
                this.value6 = element.value
              }
            })
          }
        }
      })
    },
    handleChange() {
      const data = {
        id: this.id1,
        value: this.value1
      }
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: resp => {
          this.getValue()
        }
      })
    },
    handleChange1() {
      const data = {
        id: this.id2,
        value: this.value2
      }
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: resp => {
          this.getValue()
        }
      })
    },
        handleChange2() {
      const data = {
        id: this.id8,
        value: this.value3
      }
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: resp => {
          this.getValue()
        }
      })
    },
    handleChange6() {
      const data = {
        id: this.id6,
        value: this.value6
      }
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: resp => {
          this.getValue()
        }
      })
    },
    async save() {
      try {
        // 必填校验
        await Promise.all([this.$refs.ruleForm.validate()])
      } catch (error) {
        return
      }
      const data = {
        id: this.id3,
        value: this.form.input
      }
      console.log(data, 'data')
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: (resp) => {
          this.getValue()
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
        }
      })
    },
    async saveIntegral() {
      try {
        // 必填校验
        await Promise.all([this.$refs.integralForm.validate()])
      } catch (error) {
        return
      }
      const data = {
        id: this.id4,
        degree: this.integralForm.degrees,
        point: this.integralForm.integral
      }
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: (resp) => {
          this.getValue()
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
        }
      })
    },
    async saveEmpirical() {
      try {
        // 必填校验
        await Promise.all([this.$refs.empiricalForm.validate()])
      } catch (error) {
        return
      }
      const data = {
        id: this.id5,
        degree: this.empiricalForm.degrees,
        empirical: this.empiricalForm.empirical
      }
      this.$store.dispatch('form/handle', {
        url: '/setting',
        data: data,
        method: 'post',
        callback: (resp) => {
          this.getValue()
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>

</style>



// WEBPACK FOOTER //
// src/views/systemManagement/systemSetting.vue